import { render, staticRenderFns } from "./editUniformKitProductApparel.vue?vue&type=template&id=5da3da9d"
import script from "./editUniformKitProductApparel.vue?vue&type=script&lang=js"
export * from "./editUniformKitProductApparel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports